import { render, staticRenderFns } from "./HugeScoresTable.vue?vue&type=template&id=c7079cfc&"
import script from "./HugeScoresTable.vue?vue&type=script&lang=js&"
export * from "./HugeScoresTable.vue?vue&type=script&lang=js&"
import style0 from "./HugeScoresTable.vue?vue&type=style&index=0&id=c7079cfc&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7079cfc')) {
      api.createRecord('c7079cfc', component.options)
    } else {
      api.reload('c7079cfc', component.options)
    }
    module.hot.accept("./HugeScoresTable.vue?vue&type=template&id=c7079cfc&", function () {
      api.rerender('c7079cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HugeScoresTable.vue"
export default component.exports